import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDashboardsRoutingModule } from './my-limegear.routing.module';
import { SharedModule } from '../shared/shared.module';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { MyDashboardsComponent } from './components/my-dashboards/my-dashboards.component';
import { CorporateDashboardComponent } from './components/corporate-dashboard/corporate-dashboard.component';
import { MyLimeGearTransitionComponent } from './components/my-limegear-transition/my-limegear-transition.component';
import { HistoricalTrendsCreditReportsLgcComponent } from './components/standalone-components/large-card/historical-trends-credit-reports-lgc/historical-trends-credit-reports-lgc.component';
import { ComponentsOutletDirectiveService } from './services/component-outlet-directive.service';
import { CustomDashboardsService } from './services/my-limegear.service';

@NgModule({
    declarations: [
        CorporateDashboardComponent,
        MyDashboardsComponent,
        MyLimeGearTransitionComponent,
    ],
    imports: [CommonModule, CustomDashboardsRoutingModule, SharedModule, ThirdPartyModule],
    providers: [ComponentsOutletDirectiveService, CustomDashboardsService],
    schemas: [NO_ERRORS_SCHEMA],
})
export class CustomDashboardsModule {}
